const React = require('react');
const isString = require('mn-utils/isString');
const CheckIcon = require('../../icons/Success2');
const Popup = require('./A');
const Button = require('../Button/Accept');


module.exports = (props) => {
  const info = props.args || [];
  const name = info[0] || '';
  const text = info[1] || '';
  const icon = info[2] || (<CheckIcon className="w18 c2CE889"/>);

  return (
    <Popup className={`pv60 pv40@m3 ` + props.className || ''}>
      <div className="rlv c0">
        {name ? (
          <div className="mb20 f23 fw7 tc lh34 lts0em break">
            {isString(name) ? (<span
              dangerouslySetInnerHTML={{__html: name}}
            />) : name}
          </div>
        ) : null}
        <div className="mb20 layoutRow fhaC fvaC">
          {icon}
        </div>
        {text ? (
          <div className="f12 fw3 tc lh18 lts0em break">
            {isString(text) ? (<span
              dangerouslySetInnerHTML={{__html: text}}
            />) : text}
          </div>
        ) : null}
        <div className="mt60 mt40@m3 layoutRow fhaC fvaC">
          <Button
            onClick={props.onClose}
          >OK</Button>
        </div>
      </div>
    </Popup>
  );
};
